<template>
  <span class="icon-reward-total">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 8H11V11H4H3V8H7.5ZM13 8V11H20H21V8H16.5H13ZM19.6632 6H22C22.5523 6 23 6.44772 23 7V12C23 12.5523 22.5523 13 22 13H21V22C21 22.5523 20.5523 23 20 23H12H4C3.44772 23 3 22.5523 3 22V13H2C1.44772 13 1 12.5523 1 12V7C1 6.44772 1.44772 6 2 6H4.33682C4.12085 5.54537 4 5.0368 4 4.5C4 2.567 5.567 1 7.5 1C9.46086 1 10.9214 2.16845 11.9387 4.01808C11.9594 4.05571 11.9798 4.09348 12 4.13137C12.0202 4.09348 12.0406 4.05571 12.0613 4.01808C13.0786 2.16845 14.5391 1 16.5 1C18.433 1 20 2.567 20 4.5C20 5.0368 19.8792 5.54537 19.6632 6ZM16.5 6C17.3284 6 18 5.32843 18 4.5C18 3.67157 17.3284 3 16.5 3C15.3984 3 14.5152 3.70655 13.8137 4.98192C13.6353 5.30638 13.4794 5.64992 13.3457 6H16.5ZM10.6543 6H7.5C6.67157 6 6 5.32843 6 4.5C6 3.67157 6.67157 3 7.5 3C8.60164 3 9.48483 3.70655 10.1863 4.98192C10.3647 5.30638 10.5206 5.64992 10.6543 6ZM11 13H5V21H11V13ZM13 21V13H19V21H13Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
